export const estraiDatiDisponibilitaCandidaturaLavoratore = [
  "",
  `query estraiDatiDisponibilitaCandidaturaLavoratore($input: inputEstraiDatiDisponibilitaCandidaturaLavoratore!) {
    estraiDatiDisponibilitaCandidaturaLavoratore(input: $input)
  }`,
  "estraiDatiDisponibilitaCandidaturaLavoratore"
];
